require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ../js/~/babel-runtime/~/core-js/library/modules/es7.symbol.observable.js
// module id = 628
// module chunks = 0